import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import MUIDataTable from "mui-datatables";
import DeleteIcon from "@material-ui/icons/Delete"; 
import axios from "axios";
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider
} from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const PreRegisteredAttendeesTable = props => {
  const { className, ...rest } = props;

  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const columns = ["Nombre", "Cargo","Empresa", "email", "celular", "id", "origen"];

  
  const options = {
    filter: true,
    filterType: "dropdown",
    downloadOptions: {
      filename: 'euroguss_globalfoundry_asistencia.csv'
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      const selectedIds = selectedRows.data.map(row => data[row.dataIndex].id);

      const handleOpenConfirm = () => {
        setSelectedIds(selectedIds); // ✅ Called inside event handler
        setOpenConfirm(true);
      };

      const handleCloseConfirm = () => setOpenConfirm(false);

      const handleDelete = async () => {
        try {
          var arrayDeCadenas = window.location.pathname.split('/');
          var event_id = arrayDeCadenas[arrayDeCadenas.length - 1];

          await axios.post("/api/eventos/"+event_id+"/preattendance/deleteMany", { selectedIds });
          setData(prev => prev.filter(row => !selectedIds.includes(row.id)));
          setSelectedRows([]);
        } catch (err) {
          console.error("Error deleting:", err.response?.data || err.message);
        } finally {
          handleCloseConfirm();
        }
      };

      return (
        <>
        <IconButton onClick={handleOpenConfirm} color="primary">
          <DeleteIcon style={{ color: "red" }} />
        </IconButton>

        <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
          <DialogTitle disableTypography>
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              Confirmar eliminación
            </Typography>
          </DialogTitle>

          <Divider />

          <DialogContent>
            <Typography variant="body1" style={{ marginTop: 12 }}>
              Esta acción <strong>no se puede deshacer</strong>. ¿Estás seguro de que deseas eliminar los invitados seleccionados?
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenConfirm(false)} color="primary" variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleDelete} color="secondary" variant="contained">
              Eliminar
            </Button>
          </DialogActions>
        </Dialog>

        </>
      );

    },    
 };

 // option
const downloadOptions = {
  filename: "excel-format.csv",
  separator: ";",
  filterOptions: {
  useDisplayedColumnsOnly: true,
  useDisplayedRowsOnly: true,
  }
}
  

const onDownload = (buildHead, buildBody, columns, data) => {
  return "\uFEFF" + buildHead(columns) + buildBody(data); 
} 

  //console.log(className);
  //console.log(users);
 
  const classes = useStyles();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);   

  useEffect(() => {   

    var arrayDeCadenas = window.location.pathname.split('/');
    var event_id = arrayDeCadenas[arrayDeCadenas.length - 1];

    const GetData = async () => {    
    const result = await axios.get("/api/eventos/preattendance/"+event_id);
      setData(result.data);    
    }  

    GetData();    
    //console.log(data);  
}, []);  				

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  /*
  onDownload: (buildHead, buildBody, columns, data) => {
    return "\uFEFF" + buildHead(columns) + buildBody(data);
  }
*/


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
          <MUIDataTable
                title={"Invitados registrados a la conferencia"}
                data={data}
                columns={columns}
                options={options}
            />
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

PreRegisteredAttendeesTable.propTypes = {
  className: PropTypes.string
};

export default PreRegisteredAttendeesTable;